'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = exports.UncontrolledForm = exports.ControlledForm = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var noop = function noop() {
  return {};
};

var ControlledForm = exports.ControlledForm = function (_React$Component) {
  _inherits(ControlledForm, _React$Component);

  function ControlledForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ControlledForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ControlledForm.__proto__ || Object.getPrototypeOf(ControlledForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      touched: {},
      errors: {}
    }, _this.handleChange = function (e) {
      var _e$target = e.target,
          type = _e$target.type,
          name = _e$target.name,
          value = _e$target.value,
          checked = _e$target.checked;
      var val = /^(number|range)$/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /^checkbox$/.test(type) ? checked : value;

      _this.setFieldValue(name, val, _this.props.validateOnChange);
    }, _this.handleBlur = function (e) {
      var _e$target2 = e.target,
          name = _e$target2.name,
          value = _e$target2.value;

      _this.setState(function (state) {
        return {
          touched: _extends({}, state.touched, _defineProperty({}, name, true))
        };
      }, function () {
        if (!_this.props.validateOnBlur) return;

        _this.validate(_this.props.values);
      });
    }, _this.handleSubmit = function (e) {
      e.preventDefault();
      var values = _this.props.values;

      _this.setAllTouched();

      if (_this.props.validateOnSubmit) {
        _this.validate(values, function () {
          _this.props.onSubmit(values, _this.state);
        });
      } else {
        _this.props.onSubmit(values, _this.state);
      }
    }, _this.validate = function (values, callback) {
      var errors = _this.props.validate(values);

      _this.setState({
        errors: errors
      }, callback);
    }, _this.setFieldValue = function (name, value, shouldValidate) {
      var next = _defineProperty({}, name, value);

      _this.props.onChange(next);

      if (shouldValidate) _this.validate(next);
    }, _this.setAllTouched = function () {
      var values = _this.props.values;
      var touched = {};

      for (var key in values) {
        touched[key] = true;
      }

      _this.setState({
        touched: touched
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ControlledForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          render = _props.render,
          values = _props.values;
      var _state = this.state,
          touched = _state.touched,
          errors = _state.errors;
      return render({
        values: values,
        touched: touched,
        errors: errors,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onSubmit: this.handleSubmit,
        handleBlur: this.handleBlur,
        handleChange: this.handleChange,
        handleSubmit: this.handleSubmit,
        setFieldValue: this.setFieldValue
      });
    }
  }]);

  return ControlledForm;
}(_react2.default.Component);

ControlledForm.propTypes = {
  render: _propTypes2.default.func.isRequired,
  validate: _propTypes2.default.func.isRequired,
  values: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onSubmit: _propTypes2.default.func.isRequired,
  validateOnBlur: _propTypes2.default.bool,
  validateOnChange: _propTypes2.default.bool,
  validateOnSubmit: _propTypes2.default.bool
};
ControlledForm.defaultProps = {
  values: {},
  validate: noop,
  onSubmit: noop,
  validateOnChange: true,
  validateOnBlur: true,
  validateOnSubmit: true
};

var UncontrolledForm = exports.UncontrolledForm = function (_React$Component2) {
  _inherits(UncontrolledForm, _React$Component2);

  function UncontrolledForm() {
    var _ref2;

    var _temp2, _this2, _ret2;

    _classCallCheck(this, UncontrolledForm);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_ref2 = UncontrolledForm.__proto__ || Object.getPrototypeOf(UncontrolledForm)).call.apply(_ref2, [this].concat(args))), _this2), _this2.state = {
      values: _this2.props.initialValues
    }, _this2.handleChange = function (values) {
      _this2.setState({
        values: values
      });

      _this2.props.onChange(values);
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  _createClass(UncontrolledForm, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          initialValues = _props2.initialValues,
          onChange = _props2.onChange,
          props = _objectWithoutProperties(_props2, ['initialValues', 'onChange']);

      var values = this.state.values;
      return _react2.default.createElement(Form, _extends({}, props, {
        values: values,
        onChange: this.handleChange
      }));
    }
  }]);

  return UncontrolledForm;
}(_react2.default.Component);

UncontrolledForm.propTypes = {
  initialValues: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired
};
UncontrolledForm.defaultProps = {
  initialValues: {},
  onChange: noop
};

var Form = exports.Form = function Form(props) {
  if (typeof props.onChange === 'function') {
    return _react2.default.createElement(ControlledForm, props);
  }

  return _react2.default.createElement(UncontrolledForm, props);
};

exports.default = Form;